import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock} from "@fortawesome/pro-duotone-svg-icons";
import {Typography} from "@mui/material";
import LastUpdateBox from "@/src/components/common/pages/last-update/mui-custom/last-update";
import React from "react";
import {lastUpdateFormatter} from "@/src/utils/dateFormatter";

interface LastUpdateProps {
    updatedAt: string;
}

const LastUpdate: React.FC<LastUpdateProps> = ({updatedAt}) => {
    return (
        <LastUpdateBox>
            <FontAwesomeIcon className={'icon'} icon={faClock} />
            <Typography component={'span'} mr={.25}>Last Update: </Typography>
            <Typography component={'span'} color="text.secondary">
                {
                    lastUpdateFormatter(
                        updatedAt
                    )
                }
            </Typography>
        </LastUpdateBox>
    )
}

export default LastUpdate;
